import { images } from "../routes/ImageRoutes"

export const imagesWithState = [
    {
        title: 'Chedraui',
        icon: images.chedraui
    },
    {
        title: 'BanCoppel',
        icon: images.bancoppel
    },
    {
        title: 'merza',
        icon: images.merza
    },
    {
        title: 'Lagunitas',
        icon: images.lagunitas
    },
    {
        title: 'AlSuper',
        icon: images.alsuper
    },
    {
        title: 'Ley',
        icon: images.ley
    },
    {
        title: 'cimalco',
        icon: images.cimaco
    }
];

export const imagesWithoutState = [
    {
        title: 'Soriana',
        icon: images.soriana
    },
    {
        title: "Financiera Bienestar",
        icon: images.finanBienestar,
    },
    {
        title: "7-Eleven",
        icon: images.sevenEleven,
    },
    {
        title: "Farm. Benavides",
        icon: images.fBenavides,
    },
    {
        title: "Walmart",
        icon: images.walmart,
    },
    {
        title: "Bodega Aurrera",
        icon: images.bAurrera,
    },
    {
        title: "Suburbia",
        icon: images.suburbia,
    },
    {
        title: "Six",
        icon: images.six,
    },
    {
        title: "Fund. Donde",
        icon: images.fDonde,
    },
    {
        title: "Kiosko",
        icon: images.kiosko,
    },
    // {
    //     title: "Circle K",
    //     icon: images.circleK,
    // },
    {
        title: "Waldos",
        icon: images.waldos,
    },
    {
        title: "Sams Club",
        icon: images.sams,
    },
    {
        title: "Fasti",
        icon: images.fasti,
    },
    // {
    //     title: "Superama",
    //     icon: images.superama,
    // },
    {
        title: "MTC",
        icon: images.mtc,
    },
    {
        title: "Oxxo",
        icon: images.oxxo,
    },
    {
        title: "spin-by-oxxo",
        icon: images.spin,
    },
    {
        title: "Farm. Zamora",
        icon: images.fZamora,
    },
    {
        title: "Yastas",
        icon: images.yastas,
    },
    {
        title: "Qiubo",
        icon: images.quiubo,
    },
    {
        title: "SysTienda",
        icon: images.sysTienda,
    },
    {
        title: "yomp",
        icon: images.yomp,
    },
    {
        title: "yza",
        icon: images.yza,
    },
    {
        title: "FarmaCon",
        icon: images.farmaCon,
    },
    {
        title: "Farm. Moderna",
        icon: images.moderna,
    },
    {
        title: "Generix",
        icon: images.generix,
    },
    {
        title: "Cashi",
        icon: images.cashi,
    },
    {
        title: "Farm. del Ahorro",
        icon: images.fAhorro,
    },
    {
        title: "San Pablo",
        icon: images.sanPablo,
    },
    {
        title: "Deli Smart",
        icon: images.deliSmart,
    },
    {
        title: "Aramark",
        icon: images.aramark,
    },
    {
        title: "Punto de Venta",
        icon: images.pVenta,
    },
    {
        title: "Dunosusa",
        icon: images.dunosusa,
    },
    {
        title: "San Borja",
        icon: images.sanBorja,
    },
    {
        title: "Neto",
        icon: images.neto,
    },
    {
        title: "Tony",
        icon: images.tony,
    },
    {
        title: "Ya",
        icon: images.ya,
    },
    {
        title: "Paga Todo",
        icon: images.pagaTodo,
    },
    {
        title: "Su Bodega",
        icon: images.suBodega,
    },
    {
        title: "Walmart Express",
        icon: images.wExpress,
    },
    {
        title: "Go Mart",
        icon: images.goMart,
    },
    {
        title: "Bankaool",
        icon: images.bankaool,
    },
    {
        title: "Pago Rapido",
        icon: images.pRapido,
    },
    {
        title: "Via",
        icon: images.via,
    },
    {
        title: "Paynom",
        icon: images.paynom,
    },
    {
        title: "Mavi",
        icon: images.mavi,
    },
    {
        title: "Asturiano",
        icon: images.asturiano,
    },
    // {
    //     title: "NetPay",
    //     icon: images.netPay,
    // },
    // {
    //     title: "CircleK",
    //     icon: images.circleK2,
    // },
    {
        title: "Liverpool",
        icon: images.liverpool2,
    },
    {
        title: "Mercado Pago",
        icon: images.mercadoPago,
    },
    {
        title: "San Francisco",
        icon: images.sFrancisco,
    },
    {
        title: "Extra",
        icon: images.extra,
    },
    {
        title: "Union",
        icon: images.union,
    },
    {
        title: "Farma Todo",
        icon: images.fTodo,
    },
    {
        title: "vuala",
        icon: images.vuala,
    },
    {
        title: "Plata",
        icon: images.plata,
    },
    {
        title: "Odessa",
        icon: images.odessa,
    },
    // {
    //     title: "Liverpool",
    //     icon: images.liverpool,
    // },
    {
        title: "Bbb",
        icon: images.bbb,
    },
]